import {getGifts, getPointsHistory, getMorePoints, postGiftOrder, postVisibilityProof} from './gifts';

export const apiGifts = {
  getGifts,
  getPointsHistory,
  getMorePoints,
  postGiftOrder,
  postVisibilityProof,
};
